import { UnloggedScreenLayout } from '@/components/UnloggedScreenLayout/UnloggedScreenLayout'

export const SignUp = () => {
  return <UnloggedScreenLayout />
}
